import { contractorAgreementListAPI } from "@/views/ContractorAgreementList/services/api";

export const getContractorAgreementList = async () => {
  try {
    const res = await contractorAgreementListAPI.getList();
    return res?.data;
  } catch (e) {}
};

export const saveContractorAgreementList = async (data) => {
  try {
    const res = await contractorAgreementListAPI.save(data);
    return res;
  } catch (e) {}
};

export const deleteContractorAgreementList = async (
  contractor_agreement_list_id,
) => {
  try {
    const res = await contractorAgreementListAPI.delete(
      contractor_agreement_list_id,
    );
    return res;
  } catch (e) {}
};

export const getContractors = async () => {
  try {
    const res = await contractorAgreementListAPI.getContractors();
    return res?.contractors;
  } catch (e) {}
};

export const getProviders = async () => {
  try {
    const res = await contractorAgreementListAPI.getProviders();
    return res?.data;
  } catch (e) {}
};

export const getSmetaMaterialsWithoutAgreement = async (params) => {
  try {
    const res =
      await contractorAgreementListAPI.getSmetaMaterialsWithoutAgreement(
        params,
      );
    return res?.data;
  } catch (e) {}
};

export const materialsWithoutAgreementColumns = [
  {
    name: "material_id",
    field: "material_id",
    label: "ID",
    align: "center",
    sortable: true,
    style: "width: 80px",
  },
  {
    name: "material_name",
    field: "material_name",
    label: "Материал",
    align: "left",
    sortable: true,
    style: "min-width: 200px",
  },
  {
    name: "material_price",
    field: "material_price",
    label: "Цена",
    align: "right",
    sortable: true,
    style: "width: 120px",
  },
  {
    name: "smeta_cnt",
    field: "smeta_cnt",
    label: "Кол-во по смете",
    align: "right",
    sortable: true,
    style: "width: 120px",
  },
  {
    name: "unit_name",
    field: "unit_name",
    label: "Ед. изм.",
    align: "left",
    sortable: true,
    style: "width: 100px",
  },
];

export const contractorAgreementListColumns = [
  {
    name: "contractor_agreement_list_id",
    field: "contractor_agreement_list_id",
    label: "ID",
    align: "center",
    sortable: true,
    style: "width: 80px",
  },
  {
    name: "initiator_company_type",
    field: "initiator_company_type",
    label: "",
    align: "center",
    sortable: true,
    style: "width: 44px",
  },
  {
    name: "contractor_id",
    field: "contractor_name",
    label: "Подрядчик",
    align: "left",
    sortable: true,
    style: "min-width: 150px",
  },
  {
    name: "provider_id",
    field: "provider_name",
    label: "Поставщик",
    align: "left",
    sortable: true,
    style: "min-width: 150px",
  },
  {
    name: "agreement_num",
    field: "agreement_num",
    label: "Номер договора",
    align: "left",
    sortable: true,
    style: "min-width: 150px",
  },
  {
    name: "document_date",
    field: "document_date",
    label: "Дата документа",
    align: "center",
    sortable: true,
    style: "width: 120px",
  },
  {
    name: "date_end",
    field: "date_end",
    label: "Дата окончания",
    align: "center",
    sortable: true,
    style: "width: 120px",
  },
  {
    name: "integration_status",
    field: "integration_status",
    label: "Статус",
    align: "center",
    sortable: false,
    style: "width: 100px",
  },
  {
    name: "sign_status",
    field: "sign_status",
    label: "Подписание",
    align: "left",
    sortable: false,
    style: "min-width: 180px",
  },
  {
    name: "sbs_project_name",
    field: "sbs_project_name",
    label: "Проект",
    align: "left",
    sortable: true,
    style: "min-width: 200px",
  },
  {
    name: "kod_bk",
    field: "kod_bk",
    label: "Код БК",
    align: "left",
    sortable: true,
    style: "min-width: 100px",
  },
  {
    name: "error",
    field: "error",
    label: "Ошибка",
    align: "left",
    sortable: true,
    style: "min-width: 200px",
  },
  {
    name: "guid",
    field: "guid",
    label: "GUID",
    align: "left",
    sortable: true,
    style: "min-width: 200px",
  },
  {
    name: "actions",
    field: "actions",
    label: "Действия",
    align: "center",
    style: "width: 120px",
  },
];
